import clsx from 'clsx';
import { useMemo } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { useLocalizationContext } from 'src/contexts/LocalizationContext';
import { Stack } from 'src/core/ui';
import { Listing, ListingGroup, Marketplace } from 'src/WebApiController';

import * as styles from './ListingDetailPanel.css';
import { PricingSettingAutoPriceGroup } from './PricingSetting/PricingSettingAutoPriceGroup';
import { PricingSettingGroupHeader } from './PricingSetting/PricingSettingGroupHeader';

export const ListingDetailListingGroupHeader = ({
  selectedGroup,
  flattenedListingGroup,
  useVerticalView,
  shouldDetailsSideBySide,
}: {
  selectedGroup: ListingGroup;
  flattenedListingGroup: Listing[] | undefined;
  useVerticalView: boolean;
  shouldDetailsSideBySide: boolean;
}) => {
  const { loginContext } = useAppContext();
  const { getUiCurrency } = useLocalizationContext();

  const stubHubMkpSettings =
    loginContext?.user?.activeAccount?.marketplaceSettings?.find(
      (m) => m.mkp === Marketplace.StubHub
    );

  const uiCurrency = useMemo(
    () =>
      getUiCurrency(
        selectedGroup?.currency ??
          loginContext?.user?.activeAccount?.currencyCode
      ),
    [
      getUiCurrency,
      selectedGroup?.currency,
      loginContext?.user?.activeAccount?.currencyCode,
    ]
  );

  return (
    <div
      className={clsx(styles.pricingSettingsContainerBase, {
        [styles.pricingSettingsContainerBaseRow]: shouldDetailsSideBySide,
      })}
    >
      <Stack width="full" gap="s" direction="column">
        <div className={styles.pricingSettingsHeader}>
          <PricingSettingGroupHeader
            groupName={selectedGroup.groupName}
            flattenedListingGroup={flattenedListingGroup}
          />
        </div>

        <div className={styles.pricingSettingsBody}>
          <PricingSettingAutoPriceGroup
            uiCurrency={uiCurrency}
            sellerFee={stubHubMkpSettings?.sellerFee ?? null}
            useVerticalView={useVerticalView}
          />
        </div>
      </Stack>
    </div>
  );
};
